import {fetchApiBlob} from 'shared/actions/fetchApi'
import {createBlob} from 'shared/utils/createBlob'
import {actionMap} from '../reducers/index'
import * as types from './types'
import {getMimeType} from 'shared/utils/getMimeType'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'
import querystring from 'querystring'

export default (params) => dispatch => {
    let queryParams = querystring.stringify({
        identity: params.Identity,
        issuer: params.Issuer,
        issuingTime: params.IssuingTime,
        format: params.Format
    })

    dispatch({type: types.GET_SIGCHART_START, params: params})
    dispatch(resetError())
    return fetchApiBlob('/api/fb/sigchart?' + queryParams)
        .then(response => response.text())
        .then(response => {
            dispatch({
                type: types.GET_SIGCHART_SUCCESS, response: response, params: params
            })
        }).catch(error => {
            dispatch({
                type: types.GET_SIGCHART_FAILURE, params: params
            })
            dispatch(handleError({message: error.message, title: 'Error loading sigchart.'}))
        })
}

export const handler_GET_SIGCHART_START = (reduxState, action) => {
    let newLoadingIds = reduxState.loadingIds !== undefined ? reduxState.loadingIds : []
    newLoadingIds.push(action.params)

    if (reduxState.blobUrl !== undefined)
        URL.revokeObjectURL(reduxState.blobUrl)

    return ({
        ...reduxState,
        blobUrl: undefined,
        loadingIds: newLoadingIds.slice(0)
    })
}

export const handler_GET_SIGCHART_SUCCESS = (reduxState, action) => {
    let newLoadingIds = reduxState.loadingIds !== undefined ? reduxState.loadingIds : []
    newLoadingIds = newLoadingIds.filter(item => item !== action.params)

    const blob = createBlob(action.response, getMimeType(action.params.Format), "document." + action.params.Format)

    return ({
        ...reduxState,
        blobUrl: URL.createObjectURL(blob),
        loadingIds: newLoadingIds
    })
}

export const handler_GET_SIGCHART_FAILURE = (reduxState, action) => {

    let newLoadingIds = reduxState.loadingIds !== undefined ? reduxState.loadingIds : []
    newLoadingIds = newLoadingIds.filter(item => item !== action.params)

    return ({
        ...reduxState,
        loadingIds: newLoadingIds
    })
}

actionMap[types.GET_SIGCHART_START] = handler_GET_SIGCHART_START
actionMap[types.GET_SIGCHART_SUCCESS] = handler_GET_SIGCHART_SUCCESS
actionMap[types.GET_SIGCHART_FAILURE] = handler_GET_SIGCHART_FAILURE


// WEBPACK FOOTER //
// ./src/screens/sigcharts/actions/getSigchart.js